/* eslint-disable */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { publicRoutes, protectedRoutes } from "./Routes";

const Authmiddleware = () => {
  let token = null;

  token = localStorage.getItem("token");
  return (
    <Switch>
      {/* ====== mapping of non authenticated routes start ====== */}
      {publicRoutes.map((routename, index) => (
        <Route
          path={routename.path}
          component={routename.component}
          exact
          key={index}
        />
      ))}
      {/* ====== mapping of non authenticated routes end ====== */}

      {/* ====== mapping of authenticated route start ====== */}
      {token &&
        protectedRoutes.map((routename, index) => (
          <Route
            path={routename.path}
            component={routename.component}
            exact
            key={index}
          />
        ))}

      {/* ====== mapping of authenticated route end ====== */}

      {/* ====== default redirect to dashboard ======= */}
      {!token && <Redirect to="/" />}
    </Switch>
  );
};

export default Authmiddleware;
